import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'landing-page',
      component: require('@/components/LandingPage').default
    },
    {
      path: '/check-fastpass/:checkPointId',
      name: 'check-fastpass',
      component: require('@/components/CheckFastPass').default
    },
    {
      path: '/passport',
      name: 'Passport',
      component: require('@/components/Passport').default
    },
    {
      path: '/status',
      name: 'Status',
      component: require('@/components/Status').default
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
